import {
  getTodayEndDateTime,
  getTodayStartDateTime,
} from "./reportCommon";

const reportDateTime = `${getTodayStartDateTime().split("T")[0]}T08:00`;
const todayDate = getTodayStartDateTime().split("T")[0];

export const DELHI_WARD_OPTIONS = [
  { wardId: "1", wardName: "Ward 1" },
  { wardId: "2", wardName: "Ward 2" },
  { wardId: "3", wardName: "Ward 3" },
  { wardId: "4", wardName: "Ward 4" },
  { wardId: "5", wardName: "Ward 5" },
  { wardId: "6", wardName: "Ward 6" },
  { wardId: "7", wardName: "Ward 7" },
  { wardId: "8", wardName: "Ward 8" },
  { wardId: "9", wardName: "Ward 9" },
  { wardId: "10", wardName: "Ward 10" },
  { wardId: "11", wardName: "Ward 11" },
  { wardId: "12", wardName: "Ward 12" },
];

export const PRIMARY_VEHICLE_DEPLOY_DATA = [
  { wardId: "1", wardName: "Ward 1", vehicleType: "primary2", plannedVehicles: 20, vehiclesDeployed: 20, reachedFirstPickup: 20, reportDateTime },
  { wardId: "2", wardName: "Ward 2", vehicleType: "primary2", plannedVehicles: 18, vehiclesDeployed: 17, reachedFirstPickup: 16, reportDateTime },
  { wardId: "3", wardName: "Ward 3", vehicleType: "3wheeler", plannedVehicles: 15, vehiclesDeployed: 14, reachedFirstPickup: 13, reportDateTime },
  { wardId: "4", wardName: "Ward 4", vehicleType: "primary2", plannedVehicles: 22, vehiclesDeployed: 21, reachedFirstPickup: 20, reportDateTime },
  { wardId: "5", wardName: "Ward 5", vehicleType: "3wheeler", plannedVehicles: 12, vehiclesDeployed: 12, reachedFirstPickup: 11, reportDateTime },
  { wardId: "6", wardName: "Ward 6", vehicleType: "primary2", plannedVehicles: 25, vehiclesDeployed: 23, reachedFirstPickup: 22, reportDateTime },
  { wardId: "7", wardName: "Ward 7", vehicleType: "3wheeler", plannedVehicles: 10, vehiclesDeployed: 9, reachedFirstPickup: 9, reportDateTime },
  { wardId: "8", wardName: "Ward 8", vehicleType: "primary2", plannedVehicles: 19, vehiclesDeployed: 18, reachedFirstPickup: 17, reportDateTime },
  { wardId: "9", wardName: "Ward 9", vehicleType: "primary2", plannedVehicles: 16, vehiclesDeployed: 15, reachedFirstPickup: 14, reportDateTime },
  { wardId: "10", wardName: "Ward 10", vehicleType: "3wheeler", plannedVehicles: 14, vehiclesDeployed: 13, reachedFirstPickup: 12, reportDateTime },
  { wardId: "11", wardName: "Ward 11", vehicleType: "primary2", plannedVehicles: 21, vehiclesDeployed: 20, reachedFirstPickup: 19, reportDateTime },
  { wardId: "12", wardName: "Ward 12", vehicleType: "3wheeler", plannedVehicles: 11, vehiclesDeployed: 10, reachedFirstPickup: 10, reportDateTime },
];

export const WARD_COVERAGE_DATA = [
  { wardId: "1", wardName: "Ward 1", planned: 20, vehicleDeployed: 19, totalHaltPoints: 145, clearedPoints: 132, reportDateTime },
  { wardId: "2", wardName: "Ward 2", planned: 18, vehicleDeployed: 17, totalHaltPoints: 128, clearedPoints: 115, reportDateTime },
  { wardId: "3", wardName: "Ward 3", planned: 15, vehicleDeployed: 14, totalHaltPoints: 110, clearedPoints: 98, reportDateTime },
  { wardId: "4", wardName: "Ward 4", planned: 22, vehicleDeployed: 21, totalHaltPoints: 156, clearedPoints: 140, reportDateTime },
  { wardId: "5", wardName: "Ward 5", planned: 12, vehicleDeployed: 12, totalHaltPoints: 95, clearedPoints: 88, reportDateTime },
  { wardId: "6", wardName: "Ward 6", planned: 25, vehicleDeployed: 23, totalHaltPoints: 168, clearedPoints: 150, reportDateTime },
  { wardId: "7", wardName: "Ward 7", planned: 10, vehicleDeployed: 9, totalHaltPoints: 82, clearedPoints: 74, reportDateTime },
  { wardId: "8", wardName: "Ward 8", planned: 19, vehicleDeployed: 18, totalHaltPoints: 134, clearedPoints: 121, reportDateTime },
  { wardId: "9", wardName: "Ward 9", planned: 16, vehicleDeployed: 15, totalHaltPoints: 118, clearedPoints: 105, reportDateTime },
  { wardId: "10", wardName: "Ward 10", planned: 14, vehicleDeployed: 13, totalHaltPoints: 102, clearedPoints: 91, reportDateTime },
  { wardId: "11", wardName: "Ward 11", planned: 17, vehicleDeployed: 16, totalHaltPoints: 120, clearedPoints: 108, reportDateTime },
];

export const DEFAULT_PRIMARY_VEHICLE_FILTERS = {
  wardId: "",
  vehicleType: "",
  fromDateTime: todayDate,
  toDateTime: todayDate,
};

export const DEFAULT_WARD_COVERAGE_FILTERS = {
  wardId: "",
  fromDateTime: getTodayStartDateTime(),
  toDateTime: getTodayEndDateTime(),
};

export const RC_DEPLOYMENT_DATA = [
  {
    id: "1",
    wardId: "10",
    wardName: "Ward 10",
    plannedVehicles: 10,
    inputMobileApp: 10,
    tripsToW2EAndDumpsite: 30,
    wasteType: "waste-1",
    wasteTypeName: "Waste 1",
    siteId: "dump-site",
    siteName: "Dump site",
    totalTons: 25,
    reportDateTime,
  },
  {
    id: "2",
    wardId: "10",
    wardName: "Ward 10",
    plannedVehicles: 5,
    inputMobileApp: 5,
    tripsToW2EAndDumpsite: 15,
    wasteType: "waste-2",
    wasteTypeName: "Waste 2",
    siteId: "p-and-d",
    siteName: "P&D",
    totalTons: 0,
    reportDateTime,
  },
  {
    id: "3",
    wardId: "10",
    wardName: "Ward 10",
    plannedVehicles: 5,
    inputMobileApp: 5,
    tripsToW2EAndDumpsite: 15,
    wasteType: "waste-3",
    wasteTypeName: "Waste 3",
    siteId: "dump-site",
    siteName: "Dump site",
    totalTons: 0,
    reportDateTime,
  },
];

export const DEFAULT_RC_DEPLOYMENT_FILTERS = {
  wardId: "",
  siteId: "",
  wasteType: "",
  fromDateTime: getTodayStartDateTime(),
  toDateTime: getTodayEndDateTime(),
};

export const RC_INNER_REPORT_DATA = [
  {
    id: "1",
    parentId: "1",
    wardId: "10",
    wardName: "Ward 10",
    comingFromDhalao: "Dhalao A-12",
    vehicleNo: "DL1C AB 1234",
    siteId: "dump-site",
    dumpSiteName: "Dump site",
    reportedDate: "2026-07-20",
    reportedTime: "08:15",
    tonnage: 8.5,
    picOfWbSlip: "/assets/images/user.png",
    grossWeighment: 18.2,
    tareWeighment: 9.7,
    netWeighment: 8.5,
    reportDateTime: "2026-07-20T08:15",
  },
  {
    id: "2",
    parentId: "1",
    wardId: "10",
    wardName: "Ward 10",
    comingFromDhalao: "Dhalao B-05",
    vehicleNo: "DL1C CD 5678",
    siteId: "dump-site",
    dumpSiteName: "Dump site",
    reportedDate: "2026-07-20",
    reportedTime: "09:40",
    tonnage: 9.0,
    picOfWbSlip: "/assets/images/user.png",
    grossWeighment: 19.1,
    tareWeighment: 10.1,
    netWeighment: 9.0,
    reportDateTime: "2026-07-20T09:40",
  },
  {
    id: "3",
    parentId: "2",
    wardId: "10",
    wardName: "Ward 10",
    comingFromDhalao: "Dhalao C-09",
    vehicleNo: "DL1C EF 9012",
    siteId: "p-and-d",
    dumpSiteName: "P&D",
    reportedDate: "2026-07-20",
    reportedTime: "11:05",
    tonnage: 7.5,
    picOfWbSlip: "/assets/images/user.png",
    grossWeighment: 17.0,
    tareWeighment: 9.5,
    netWeighment: 7.5,
    reportDateTime: "2026-07-20T11:05",
  },
];

export const DEFAULT_RC_INNER_FILTERS = {
  vehicleNumber: "",
  site: "",
  fromDateTime: getTodayStartDateTime(),
  toDateTime: getTodayEndDateTime(),
};

export const TRIP_TO_FCTS_DATA = [
  {
    id: "1",
    fctsId: "fcts-1",
    fctsName: "Name of the location1",
    vehicleType: "primary2",
    uniqueVehicles: 2,
    totalReported: 6,
    trips1: 0,
    trips2: 2,
    trips3: 0,
    moreThan4: 0,
    reportDateTime,
  },
  {
    id: "2",
    fctsId: "fcts-2",
    fctsName: "Name of the location2",
    vehicleType: "primary2",
    uniqueVehicles: 1,
    totalReported: 2,
    trips1: 0,
    trips2: 1,
    trips3: 0,
    moreThan4: 0,
    reportDateTime,
  },
  {
    id: "3",
    fctsId: "fcts-3",
    fctsName: "Name of the location3",
    vehicleType: "3wheeler",
    uniqueVehicles: 3,
    totalReported: 4,
    trips1: 1,
    trips2: 1,
    trips3: 1,
    moreThan4: 0,
    reportDateTime,
  },
];

export const DEFAULT_TRIP_TO_FCTS_FILTERS = {
  fctsId: "",
  vehicleType: "",
  fromDateTime: getTodayStartDateTime(),
  toDateTime: getTodayEndDateTime(),
};

export const OVERVIEW_SECONDARY_COLLECTION_DATA = [
  {
    id: "1",
    typeOfWaste: "1) Municipal Solid Waste (GVP)",
    totalPoint: 120,
    cleared: 95,
    notCleared: 20,
    balance: 5,
    reportDateTime,
  },
  {
    id: "2",
    typeOfWaste: "2) Street Sweeping Waste (BIN)",
    totalPoint: 80,
    cleared: 70,
    notCleared: 8,
    balance: 2,
    reportDateTime,
  },
  {
    id: "3",
    typeOfWaste: "3) Desilted Waste",
    totalPoint: 45,
    cleared: 30,
    notCleared: 12,
    balance: 3,
    reportDateTime,
  },
  {
    id: "4",
    typeOfWaste: "4) Horticulture Waste",
    totalPoint: 60,
    cleared: 48,
    notCleared: 10,
    balance: 2,
    reportDateTime,
  },
  {
    id: "5",
    typeOfWaste: "5) Commercial waste (BWG)",
    totalPoint: 55,
    cleared: 40,
    notCleared: 12,
    balance: 3,
    reportDateTime,
  },
  {
    id: "6",
    typeOfWaste: "6) Dhalao",
    totalPoint: 35,
    cleared: 28,
    notCleared: 5,
    balance: 2,
    reportDateTime,
  },
  {
    id: "7",
    typeOfWaste: "7) Others (Hotspot)",
    totalPoint: 25,
    cleared: 18,
    notCleared: 5,
    balance: 2,
    reportDateTime,
  },
  {
    id: "8",
    typeOfWaste: "8) FCTS",
    totalPoint: 40,
    cleared: 32,
    notCleared: 6,
    balance: 2,
    reportDateTime,
  },
];

export const DEFAULT_OVERVIEW_SECONDARY_COLLECTION_FILTERS = {
  fromDateTime: getTodayStartDateTime(),
  toDateTime: getTodayEndDateTime(),
};

export const OVERVIEW_SECONDARY_COLLECTION_INNER_DATA = [
  {
    id: "1-1",
    parentId: "1",
    wasteTypeId: "1",
    wardId: "1",
    wardName: "Ward 1",
    typeOfWaste: "1) Municipal Solid Waste (GVP)",
    totalPoint: 20,
    cleared: 16,
    notCleared: 3,
    balance: 1,
    reportDateTime,
  },
  {
    id: "1-2",
    parentId: "2",
    wasteTypeId: "2",
    wardId: "1",
    wardName: "Ward 1",
    typeOfWaste: "2) Street Sweeping Waste (BIN)",
    totalPoint: 30,
    cleared: 24,
    notCleared: 4,
    balance: 2,
    reportDateTime,
  },
  {
    id: "1-3",
    parentId: "3",
    wasteTypeId: "3",
    wardId: "1",
    wardName: "Ward 1",
    typeOfWaste: "3) Desilted Waste",
    totalPoint: 2,
    cleared: 1,
    notCleared: 1,
    balance: 0,
    reportDateTime,
  },
  {
    id: "1-4",
    parentId: "4",
    wasteTypeId: "4",
    wardId: "1",
    wardName: "Ward 1",
    typeOfWaste: "4) Horticulture Waste",
    totalPoint: 2,
    cleared: 2,
    notCleared: 0,
    balance: 0,
    reportDateTime,
  },
  {
    id: "1-5",
    parentId: "5",
    wasteTypeId: "5",
    wardId: "1",
    wardName: "Ward 1",
    typeOfWaste: "5) Commercial waste (BWG)",
    totalPoint: 2,
    cleared: 1,
    notCleared: 1,
    balance: 0,
    reportDateTime,
  },
  {
    id: "1-6",
    parentId: "6",
    wasteTypeId: "6",
    wardId: "1",
    wardName: "Ward 1",
    typeOfWaste: "6) Dhalao",
    totalPoint: 2,
    cleared: 2,
    notCleared: 0,
    balance: 0,
    reportDateTime,
  },
  {
    id: "1-7",
    parentId: "7",
    wasteTypeId: "7",
    wardId: "1",
    wardName: "Ward 1",
    typeOfWaste: "7) Others (Hotspot)",
    totalPoint: 2,
    cleared: 1,
    notCleared: 1,
    balance: 0,
    reportDateTime,
  },
  {
    id: "1-8",
    parentId: "8",
    wasteTypeId: "8",
    wardId: "1",
    wardName: "Ward 1",
    typeOfWaste: "8) FCTS",
    totalPoint: 3,
    cleared: 2,
    notCleared: 1,
    balance: 0,
    reportDateTime,
  },
  {
    id: "2-1",
    parentId: "1",
    wasteTypeId: "1",
    wardId: "2",
    wardName: "Ward 2",
    typeOfWaste: "1) Municipal Solid Waste (GVP)",
    totalPoint: 18,
    cleared: 14,
    notCleared: 3,
    balance: 1,
    reportDateTime,
  },
  {
    id: "2-2",
    parentId: "2",
    wasteTypeId: "2",
    wardId: "2",
    wardName: "Ward 2",
    typeOfWaste: "2) Street Sweeping Waste (BIN)",
    totalPoint: 25,
    cleared: 20,
    notCleared: 4,
    balance: 1,
    reportDateTime,
  },
  {
    id: "2-3",
    parentId: "3",
    wasteTypeId: "3",
    wardId: "2",
    wardName: "Ward 2",
    typeOfWaste: "3) Desilted Waste",
    totalPoint: 3,
    cleared: 2,
    notCleared: 1,
    balance: 0,
    reportDateTime,
  },
  {
    id: "2-4",
    parentId: "4",
    wasteTypeId: "4",
    wardId: "2",
    wardName: "Ward 2",
    typeOfWaste: "4) Horticulture Waste",
    totalPoint: 2,
    cleared: 1,
    notCleared: 1,
    balance: 0,
    reportDateTime,
  },
  {
    id: "2-5",
    parentId: "5",
    wasteTypeId: "5",
    wardId: "2",
    wardName: "Ward 2",
    typeOfWaste: "5) Commercial waste (BWG)",
    totalPoint: 2,
    cleared: 1,
    notCleared: 1,
    balance: 0,
    reportDateTime,
  },
  {
    id: "2-6",
    parentId: "6",
    wasteTypeId: "6",
    wardId: "2",
    wardName: "Ward 2",
    typeOfWaste: "6) Dhalao",
    totalPoint: 2,
    cleared: 2,
    notCleared: 0,
    balance: 0,
    reportDateTime,
  },
  {
    id: "2-7",
    parentId: "7",
    wasteTypeId: "7",
    wardId: "2",
    wardName: "Ward 2",
    typeOfWaste: "7) Others (Hotspot)",
    totalPoint: 2,
    cleared: 1,
    notCleared: 1,
    balance: 0,
    reportDateTime,
  },
  {
    id: "2-8",
    parentId: "8",
    wasteTypeId: "8",
    wardId: "2",
    wardName: "Ward 2",
    typeOfWaste: "8) FCTS",
    totalPoint: 4,
    cleared: 3,
    notCleared: 1,
    balance: 0,
    reportDateTime,
  },
  {
    id: "3-1",
    parentId: "1",
    wasteTypeId: "1",
    wardId: "3",
    wardName: "Ward 3",
    typeOfWaste: "1) Municipal Solid Waste (GVP)",
    totalPoint: 15,
    cleared: 12,
    notCleared: 2,
    balance: 1,
    reportDateTime,
  },
  {
    id: "3-2",
    parentId: "2",
    wasteTypeId: "2",
    wardId: "3",
    wardName: "Ward 3",
    typeOfWaste: "2) Street Sweeping Waste (BIN)",
    totalPoint: 22,
    cleared: 18,
    notCleared: 3,
    balance: 1,
    reportDateTime,
  },
  {
    id: "3-3",
    parentId: "3",
    wasteTypeId: "3",
    wardId: "3",
    wardName: "Ward 3",
    typeOfWaste: "3) Desilted Waste",
    totalPoint: 2,
    cleared: 1,
    notCleared: 1,
    balance: 0,
    reportDateTime,
  },
  {
    id: "3-4",
    parentId: "4",
    wasteTypeId: "4",
    wardId: "3",
    wardName: "Ward 3",
    typeOfWaste: "4) Horticulture Waste",
    totalPoint: 2,
    cleared: 2,
    notCleared: 0,
    balance: 0,
    reportDateTime,
  },
  {
    id: "3-5",
    parentId: "5",
    wasteTypeId: "5",
    wardId: "3",
    wardName: "Ward 3",
    typeOfWaste: "5) Commercial waste (BWG)",
    totalPoint: 2,
    cleared: 1,
    notCleared: 1,
    balance: 0,
    reportDateTime,
  },
  {
    id: "3-6",
    parentId: "6",
    wasteTypeId: "6",
    wardId: "3",
    wardName: "Ward 3",
    typeOfWaste: "6) Dhalao",
    totalPoint: 2,
    cleared: 2,
    notCleared: 0,
    balance: 0,
    reportDateTime,
  },
  {
    id: "3-7",
    parentId: "7",
    wasteTypeId: "7",
    wardId: "3",
    wardName: "Ward 3",
    typeOfWaste: "7) Others (Hotspot)",
    totalPoint: 2,
    cleared: 1,
    notCleared: 1,
    balance: 0,
    reportDateTime,
  },
  {
    id: "3-8",
    parentId: "8",
    wasteTypeId: "8",
    wardId: "3",
    wardName: "Ward 3",
    typeOfWaste: "8) FCTS",
    totalPoint: 3,
    cleared: 2,
    notCleared: 1,
    balance: 0,
    reportDateTime,
  },
];

export const DEFAULT_OVERVIEW_SECONDARY_COLLECTION_INNER_FILTERS = {
  wardId: "",
  fromDateTime: getTodayStartDateTime(),
  toDateTime: getTodayEndDateTime(),
};

export const HOOK_LOADER_REPORT_DATA = [
  {
    id: "1",
    wardId: "1",
    wardName: "Ward 1",
    vehicleNo: "DL1C HL 1001",
    totalTrip: 8,
    tonnage: 42.5,
    reportDateTime,
  },
  {
    id: "2",
    wardId: "2",
    wardName: "Ward 2",
    vehicleNo: "DL1C HL 1002",
    totalTrip: 5,
    tonnage: 28.0,
    reportDateTime,
  },
  {
    id: "3",
    wardId: "3",
    wardName: "Ward 3",
    vehicleNo: "DL1C HL 1003",
    totalTrip: 6,
    tonnage: 33.2,
    reportDateTime,
  },
  {
    id: "4",
    wardId: "4",
    wardName: "Ward 4",
    vehicleNo: "DL1C HL 1004",
    totalTrip: 4,
    tonnage: 21.8,
    reportDateTime,
  },
  {
    id: "5",
    wardId: "5",
    wardName: "Ward 5",
    vehicleNo: "DL1C HL 1005",
    totalTrip: 7,
    tonnage: 37.6,
    reportDateTime,
  },
];

export const DEFAULT_HOOK_LOADER_FILTERS = {
  wardId: "",
  vehicleNo: "",
  fromDate: getTodayStartDateTime(),
  toDate: getTodayEndDateTime(),
};

export const HOOK_LOADER_INNER_REPORT_DATA = [
  {
    id: "1",
    parentId: "1",
    wardId: "1",
    wardName: "Ward 1",
    vehicleNo: "DL1C HL 1001",
    fctsId: "fcts-okhla",
    fctsName: "Okhla FCTS",
    dumpsiteId: "dump-bhalswa",
    dumpsiteName: "Bhalswa Dumpsite",
    reportedDate: "2026-07-20",
    reportedTime: "08:15",
    tonnage: 5.5,
    picOfWbSlip: "/assets/images/user.png",
    grossWeighment: 15.2,
    tareWeighment: 9.7,
    netWeighment: 5.5,
    reportDateTime: "2026-07-20T08:15",
  },
  {
    id: "2",
    parentId: "1",
    wardId: "1",
    wardName: "Ward 1",
    vehicleNo: "DL1C HL 1001",
    fctsId: "fcts-okhla",
    fctsName: "Okhla FCTS",
    dumpsiteId: "dump-gazipur",
    dumpsiteName: "Gazipur Dumpsite",
    reportedDate: "2026-07-20",
    reportedTime: "10:30",
    tonnage: 5.2,
    picOfWbSlip: "/assets/images/user.png",
    grossWeighment: 14.8,
    tareWeighment: 9.6,
    netWeighment: 5.2,
    reportDateTime: "2026-07-20T10:30",
  },
  {
    id: "3",
    parentId: "1",
    wardId: "1",
    wardName: "Ward 1",
    vehicleNo: "DL1C HL 1001",
    fctsId: "fcts-gazipur",
    fctsName: "Gazipur FCTS",
    dumpsiteId: "dump-okhla",
    dumpsiteName: "Okhla Dumpsite",
    reportedDate: "2026-07-20",
    reportedTime: "12:45",
    tonnage: 5.8,
    picOfWbSlip: "/assets/images/user.png",
    grossWeighment: 15.5,
    tareWeighment: 9.7,
    netWeighment: 5.8,
    reportDateTime: "2026-07-20T12:45",
  },
  {
    id: "4",
    parentId: "2",
    wardId: "2",
    wardName: "Ward 2",
    vehicleNo: "DL1C HL 1002",
    fctsId: "fcts-gazipur",
    fctsName: "Gazipur FCTS",
    dumpsiteId: "dump-bhalswa",
    dumpsiteName: "Bhalswa Dumpsite",
    reportedDate: "2026-07-20",
    reportedTime: "09:10",
    tonnage: 5.6,
    picOfWbSlip: "/assets/images/user.png",
    grossWeighment: 15.1,
    tareWeighment: 9.5,
    netWeighment: 5.6,
    reportDateTime: "2026-07-20T09:10",
  },
  {
    id: "5",
    parentId: "2",
    wardId: "2",
    wardName: "Ward 2",
    vehicleNo: "DL1C HL 1002",
    fctsId: "fcts-narela",
    fctsName: "Narela FCTS",
    dumpsiteId: "dump-gazipur",
    dumpsiteName: "Gazipur Dumpsite",
    reportedDate: "2026-07-20",
    reportedTime: "11:20",
    tonnage: 5.4,
    picOfWbSlip: "/assets/images/user.png",
    grossWeighment: 14.9,
    tareWeighment: 9.5,
    netWeighment: 5.4,
    reportDateTime: "2026-07-20T11:20",
  },
  {
    id: "6",
    parentId: "3",
    wardId: "3",
    wardName: "Ward 3",
    vehicleNo: "DL1C HL 1003",
    fctsId: "fcts-okhla",
    fctsName: "Okhla FCTS",
    dumpsiteId: "dump-okhla",
    dumpsiteName: "Okhla Dumpsite",
    reportedDate: "2026-07-20",
    reportedTime: "08:50",
    tonnage: 5.7,
    picOfWbSlip: "/assets/images/user.png",
    grossWeighment: 15.3,
    tareWeighment: 9.6,
    netWeighment: 5.7,
    reportDateTime: "2026-07-20T08:50",
  },
  {
    id: "7",
    parentId: "4",
    wardId: "4",
    wardName: "Ward 4",
    vehicleNo: "DL1C HL 1004",
    fctsId: "fcts-narela",
    fctsName: "Narela FCTS",
    dumpsiteId: "dump-bhalswa",
    dumpsiteName: "Bhalswa Dumpsite",
    reportedDate: "2026-07-20",
    reportedTime: "13:05",
    tonnage: 5.3,
    picOfWbSlip: "/assets/images/user.png",
    grossWeighment: 14.8,
    tareWeighment: 9.5,
    netWeighment: 5.3,
    reportDateTime: "2026-07-20T13:05",
  },
  {
    id: "8",
    parentId: "5",
    wardId: "5",
    wardName: "Ward 5",
    vehicleNo: "DL1C HL 1005",
    fctsId: "fcts-gazipur",
    fctsName: "Gazipur FCTS",
    dumpsiteId: "dump-gazipur",
    dumpsiteName: "Gazipur Dumpsite",
    reportedDate: "2026-07-20",
    reportedTime: "14:25",
    tonnage: 5.9,
    picOfWbSlip: "/assets/images/user.png",
    grossWeighment: 15.6,
    tareWeighment: 9.7,
    netWeighment: 5.9,
    reportDateTime: "2026-07-20T14:25",
  },
];

export const DEFAULT_HOOK_LOADER_INNER_FILTERS = {
  wardId: "",
  vehicleNo: "",
  fctsId: "",
  dumpsiteId: "",
  fromDateTime: "",
  toDateTime: "",
};

// ------------------------------
// Vehicle wise coverage (halt points)
// ------------------------------
export const VEHICLE_COVERAGE_DATA = [
  {
    id: "v1",
    wardId: "1",
    wardName: "Ward 10",
    vehicleNo: "v1",
    totalHaltPoints: 30,
    clearedPoints: 20,
    reportDateTime: `${todayDate}T08:15`,
  },
  {
    id: "v2",
    wardId: "1",
    wardName: "Ward 10",
    vehicleNo: "v2",
    totalHaltPoints: 30,
    clearedPoints: 15,
    reportDateTime: `${todayDate}T09:10`,
  },
  {
    id: "v3",
    wardId: "1",
    wardName: "Ward 10",
    vehicleNo: "v3",
    totalHaltPoints: 20,
    clearedPoints: 0,
    reportDateTime: `${todayDate}T10:30`,
  },
  {
    id: "v4",
    wardId: "1",
    wardName: "Ward 10",
    vehicleNo: "v4",
    totalHaltPoints: 25,
    clearedPoints: 10,
    reportDateTime: `${todayDate}T11:05`,
  },
  {
    id: "v5",
    wardId: "1",
    wardName: "Ward 10",
    vehicleNo: "v5",
    totalHaltPoints: 35,
    clearedPoints: 25,
    reportDateTime: `${todayDate}T12:45`,
  },
  {
    id: "v6",
    wardId: "1",
    wardName: "Ward 10",
    vehicleNo: "v6",
    totalHaltPoints: 30,
    clearedPoints: 20,
    reportDateTime: `${todayDate}T14:25`,
  },
];

export const DEFAULT_VEHICLE_COVERAGE_FILTERS = {
  vehicleNo: "",
  fromDateTime: getTodayStartDateTime(),
  toDateTime: getTodayEndDateTime(),
};

export const VEHICLE_CLEARED_HALT_POINTS_DATA = [
  {
    id: "hp-v1-1",
    vehicleId: "v1",
    vehicleNo: "v1",
    haltPoint: "HP-001",
    time: "08:20",
    status: "Cleared",
    latitude: "17.456789",
    longitude: "78.456789",
    image: "/assets/images/user.png",
    clearedAt: `${todayDate}T08:20`,
  },
  {
    id: "hp-v1-2",
    vehicleId: "v1",
    vehicleNo: "v1",
    haltPoint: "HP-002",
    time: "08:45",
    status: "Cleared",
    latitude: "17.457100",
    longitude: "78.457200",
    image: "/assets/images/user.png",
    clearedAt: `${todayDate}T08:45`,
  },
  {
    id: "hp-v1-3",
    vehicleId: "v1",
    vehicleNo: "v1",
    haltPoint: "HP-003",
    time: "09:10",
    status: "Cleared",
    latitude: "17.457500",
    longitude: "78.457800",
    image: "/assets/images/user.png",
    clearedAt: `${todayDate}T09:10`,
  },
  {
    id: "hp-v1-4",
    vehicleId: "v1",
    vehicleNo: "v1",
    haltPoint: "HP-004",
    time: "09:35",
    status: "Cleared",
    latitude: "17.458000",
    longitude: "78.458300",
    image: "/assets/images/user.png",
    clearedAt: `${todayDate}T09:35`,
  },
  {
    id: "hp-v1-5",
    vehicleId: "v1",
    vehicleNo: "v1",
    haltPoint: "HP-005",
    time: "10:00",
    status: "Cleared",
    latitude: "17.458400",
    longitude: "78.458900",
    image: "/assets/images/user.png",
    clearedAt: `${todayDate}T10:00`,
  },
  {
    id: "hp-v2-1",
    vehicleId: "v2",
    vehicleNo: "v2",
    haltPoint: "HP-101",
    time: "09:15",
    status: "Cleared",
    latitude: "17.460100",
    longitude: "78.460200",
    image: "/assets/images/user.png",
    clearedAt: `${todayDate}T09:15`,
  },
  {
    id: "hp-v2-2",
    vehicleId: "v2",
    vehicleNo: "v2",
    haltPoint: "HP-102",
    time: "09:40",
    status: "Cleared",
    latitude: "17.460800",
    longitude: "78.461000",
    image: "/assets/images/user.png",
    clearedAt: `${todayDate}T09:40`,
  },
  {
    id: "hp-v2-3",
    vehicleId: "v2",
    vehicleNo: "v2",
    haltPoint: "HP-103",
    time: "10:05",
    status: "Cleared",
    latitude: "17.461500",
    longitude: "78.461800",
    image: "/assets/images/user.png",
    clearedAt: `${todayDate}T10:05`,
  },
  {
    id: "hp-v4-1",
    vehicleId: "v4",
    vehicleNo: "v4",
    haltPoint: "HP-201",
    time: "11:10",
    status: "Cleared",
    latitude: "17.470200",
    longitude: "78.470100",
    image: "/assets/images/user.png",
    clearedAt: `${todayDate}T11:10`,
  },
  {
    id: "hp-v4-2",
    vehicleId: "v4",
    vehicleNo: "v4",
    haltPoint: "HP-202",
    time: "11:35",
    status: "Cleared",
    latitude: "17.470900",
    longitude: "78.471300",
    image: "/assets/images/user.png",
    clearedAt: `${todayDate}T11:35`,
  },
  {
    id: "hp-v5-1",
    vehicleId: "v5",
    vehicleNo: "v5",
    haltPoint: "HP-301",
    time: "12:50",
    status: "Cleared",
    latitude: "17.480100",
    longitude: "78.480000",
    image: "/assets/images/user.png",
    clearedAt: `${todayDate}T12:50`,
  },
  {
    id: "hp-v5-2",
    vehicleId: "v5",
    vehicleNo: "v5",
    haltPoint: "HP-302",
    time: "13:15",
    status: "Cleared",
    latitude: "17.480800",
    longitude: "78.481200",
    image: "/assets/images/user.png",
    clearedAt: `${todayDate}T13:15`,
  },
  {
    id: "hp-v5-3",
    vehicleId: "v5",
    vehicleNo: "v5",
    haltPoint: "HP-303",
    time: "13:40",
    status: "Cleared",
    latitude: "17.481500",
    longitude: "78.482400",
    image: "/assets/images/user.png",
    clearedAt: `${todayDate}T13:40`,
  },
  {
    id: "hp-v6-1",
    vehicleId: "v6",
    vehicleNo: "v6",
    haltPoint: "HP-401",
    time: "14:30",
    status: "Cleared",
    latitude: "17.490200",
    longitude: "78.490100",
    image: "/assets/images/user.png",
    clearedAt: `${todayDate}T14:30`,
  },
  {
    id: "hp-v6-2",
    vehicleId: "v6",
    vehicleNo: "v6",
    haltPoint: "HP-402",
    time: "14:55",
    status: "Cleared",
    latitude: "17.490900",
    longitude: "78.491300",
    image: "/assets/images/user.png",
    clearedAt: `${todayDate}T14:55`,
  },
];

export const VEHICLE_BALANCE_HALT_POINTS_DATA = [
  {
    id: "bp-v1-1",
    vehicleId: "v1",
    vehicleNo: "v1",
    haltPoint: "HP-006",
    latitude: "17.458900",
    longitude: "78.459200",
    location: "Sector 12 Market",
    status: "Pending",
  },
  {
    id: "bp-v1-2",
    vehicleId: "v1",
    vehicleNo: "v1",
    haltPoint: "HP-007",
    latitude: "17.459300",
    longitude: "78.459700",
    location: "Colony Gate A",
    status: "Pending",
  },
  {
    id: "bp-v1-3",
    vehicleId: "v1",
    vehicleNo: "v1",
    haltPoint: "HP-008",
    latitude: "17.459800",
    longitude: "78.460100",
    location: "Park Road Junction",
    status: "Pending",
  },
  {
    id: "bp-v1-4",
    vehicleId: "v1",
    vehicleNo: "v1",
    haltPoint: "HP-009",
    latitude: "17.460200",
    longitude: "78.460600",
    location: "Bus Stand Lane",
    status: "Pending",
  },
  {
    id: "bp-v1-5",
    vehicleId: "v1",
    vehicleNo: "v1",
    haltPoint: "HP-010",
    latitude: "17.460700",
    longitude: "78.461100",
    location: "Temple Street",
    status: "Pending",
  },
  {
    id: "bp-v2-1",
    vehicleId: "v2",
    vehicleNo: "v2",
    haltPoint: "HP-104",
    latitude: "17.462000",
    longitude: "78.462300",
    location: "Ward Office Road",
    status: "Pending",
  },
  {
    id: "bp-v2-2",
    vehicleId: "v2",
    vehicleNo: "v2",
    haltPoint: "HP-105",
    latitude: "17.462500",
    longitude: "78.462800",
    location: "School Crossing",
    status: "Pending",
  },
  {
    id: "bp-v2-3",
    vehicleId: "v2",
    vehicleNo: "v2",
    haltPoint: "HP-106",
    latitude: "17.463000",
    longitude: "78.463400",
    location: "Community Hall",
    status: "Pending",
  },
  {
    id: "bp-v3-1",
    vehicleId: "v3",
    vehicleNo: "v3",
    haltPoint: "HP-501",
    latitude: "17.465100",
    longitude: "78.465200",
    location: "Main Market Circle",
    status: "Pending",
  },
  {
    id: "bp-v3-2",
    vehicleId: "v3",
    vehicleNo: "v3",
    haltPoint: "HP-502",
    latitude: "17.465600",
    longitude: "78.465800",
    location: "Housing Colony B",
    status: "Pending",
  },
  {
    id: "bp-v3-3",
    vehicleId: "v3",
    vehicleNo: "v3",
    haltPoint: "HP-503",
    latitude: "17.466100",
    longitude: "78.466300",
    location: "Nala Side Road",
    status: "Pending",
  },
  {
    id: "bp-v4-1",
    vehicleId: "v4",
    vehicleNo: "v4",
    haltPoint: "HP-203",
    latitude: "17.471500",
    longitude: "78.471800",
    location: "Industrial Area Gate",
    status: "Pending",
  },
  {
    id: "bp-v4-2",
    vehicleId: "v4",
    vehicleNo: "v4",
    haltPoint: "HP-204",
    latitude: "17.472000",
    longitude: "78.472400",
    location: "Depot Approach Road",
    status: "Pending",
  },
  {
    id: "bp-v5-1",
    vehicleId: "v5",
    vehicleNo: "v5",
    haltPoint: "HP-304",
    latitude: "17.482000",
    longitude: "78.482700",
    location: "Ring Road Dump",
    status: "Pending",
  },
  {
    id: "bp-v5-2",
    vehicleId: "v5",
    vehicleNo: "v5",
    haltPoint: "HP-305",
    latitude: "17.482600",
    longitude: "78.483200",
    location: "Service Lane 4",
    status: "Pending",
  },
  {
    id: "bp-v6-1",
    vehicleId: "v6",
    vehicleNo: "v6",
    haltPoint: "HP-403",
    latitude: "17.491500",
    longitude: "78.491800",
    location: "Zone Boundary Point",
    status: "Pending",
  },
  {
    id: "bp-v6-2",
    vehicleId: "v6",
    vehicleNo: "v6",
    haltPoint: "HP-404",
    latitude: "17.492000",
    longitude: "78.492400",
    location: "Transfer Station Road",
    status: "Pending",
  },
];

export const DEFAULT_IEC_ACTIVITY_FILTERS = {
  wardId: "",
  fromDateTime: getTodayStartDateTime(),
  toDateTime: getTodayEndDateTime(),
};

export const IEC_ACTIVITY_REPORT_DATA = [
  {
    id: "1",
    zoneName: "Central",
    wardId: "1",
    wardName: "Ward 1",
    dateOfCreation: todayDate,
    activityType: "Awareness Camp",
    conductedArea: "Residential Colony",
    location: "Block A Community Hall",
    remarks: "Segregation awareness session conducted",
    image: "/assets/images/user.png",
    reportDateTime,
  },
  {
    id: "2",
    zoneName: "South",
    wardId: "2",
    wardName: "Ward 2",
    dateOfCreation: todayDate,
    activityType: "Street Play",
    conductedArea: "Market Area",
    location: "Main Market Chowk",
    remarks: "IEC street play on wet/dry waste",
    image: "/assets/images/user.png",
    reportDateTime,
  },
  {
    id: "3",
    zoneName: "East",
    wardId: "3",
    wardName: "Ward 3",
    dateOfCreation: todayDate,
    activityType: "Door to Door Campaign",
    conductedArea: "Residential Area",
    location: "Sector 12 Lane 4",
    remarks: "Leaflet distribution completed",
    image: "/assets/images/user.png",
    reportDateTime,
  },
  {
    id: "4",
    zoneName: "West",
    wardId: "4",
    wardName: "Ward 4",
    dateOfCreation: todayDate,
    activityType: "School Programme",
    conductedArea: "Educational Institute",
    location: "Govt. Sr. Sec. School",
    remarks: "Student orientation on SWM",
    image: "/assets/images/user.png",
    reportDateTime,
  },
  {
    id: "5",
    zoneName: "North",
    wardId: "5",
    wardName: "Ward 5",
    dateOfCreation: todayDate,
    activityType: "Public Meeting",
    conductedArea: "Park Area",
    location: "Ward Park Ground",
    remarks: "RWA meeting on composting",
    image: "/assets/images/user.png",
    reportDateTime,
  },
  {
    id: "6",
    zoneName: "Central",
    wardId: "6",
    wardName: "Ward 6",
    dateOfCreation: todayDate,
    activityType: "Nukkad Natak",
    conductedArea: "Public Place",
    location: "Bus Stand Circle",
    remarks: "Crowd participation was good",
    image: "/assets/images/user.png",
    reportDateTime,
  },
  {
    id: "7",
    zoneName: "South",
    wardId: "7",
    wardName: "Ward 7",
    dateOfCreation: todayDate,
    activityType: "Training Session",
    conductedArea: "Office Premises",
    location: "Zone Office Hall",
    remarks: "Safai mitra training completed",
    image: "/assets/images/user.png",
    reportDateTime,
  },
  {
    id: "8",
    zoneName: "East",
    wardId: "8",
    wardName: "Ward 8",
    dateOfCreation: todayDate,
    activityType: "Awareness Rally",
    conductedArea: "Main Road",
    location: "Ring Road Stretch",
    remarks: "Rally from depot to circle",
    image: "/assets/images/user.png",
    reportDateTime,
  },
];
